import React, { useContext, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme, Search, ColorBadge, SelectOption, Select, LoadingLine } from '@spoiler-alert/ui-library';

const gap = 10;
const border = `2px solid ${Theme.tableBorderColor}`;

const useStyles = createUseStyles({
  wrap: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap,
  },
  title: {
    fontSize: '20px',
    margin: 0,
  },
  topSection: {
    display: 'flex',
    flexDirection: 'row',
    gap,
    width: '100%',
    border: border,
    position: 'relative',
  },
  topMiddle: {
    display: 'flex',
    flexDirection: 'column',
    gap,
    width: '100%',
    flexGrow: 1,
    padding: [gap, 0],
  },
  topUpperMiddle: {
    display: 'flex',
    flexDirection: 'row',
    gap,
    flexGrow: 1,
  },
  documents: {
    width: 400,
    borderRight: border,
    padding: gap,
  },
  actions: {
    width: 300,
    borderLeft: border,
    padding: gap,
  },
  box: {
    border,
    padding: gap,
  },
  halfBox: {
    extend: 'box',
    width: '50%',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap,
  },
});

interface POManagerDetailLayoutProps {
  title: React.ReactNode;
  table: React.ReactNode;
  documents: React.ReactNode;
  actions: React.ReactNode;
  middleLeft: React.ReactNode;
  middleRight: React.ReactNode;
  middleCenter?: React.ReactNode;
  loading?: boolean;
}

const POManagerDetailLayout: React.FC<POManagerDetailLayoutProps> = ({
  title,
  table,
  documents,
  actions,
  middleCenter,
  middleLeft,
  middleRight,
  loading = false,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrap}>
      <h1 className={classes.title}>{title}</h1>
      <div className={classes.topSection}>
        <LoadingLine loading={loading} />
        <div className={classes.documents}>{documents}</div>
        <div className={classes.topMiddle}>
          <div className={classes.topUpperMiddle}>
            <div className={classes.halfBox}>{middleLeft}</div>
            <div className={classes.halfBox}>{middleRight}</div>
          </div>
          {middleCenter && <div className={classes.box}>{middleCenter}</div>}
        </div>
        <div className={classes.actions}>{actions}</div>
      </div>
      <div className={classes.table}>{table}</div>
    </div>
  );
};

export default POManagerDetailLayout;
